import "./index.css";

import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import AboutMePage from "@/pages/AboutMe";
import App from "./App";
import { BaseContextProvider } from "@/utility/state/contextAPI";
import CountryDetailedList from "@/localData/countryDetailedList";
import CountryMainTemplate from "./pages/Countries/CountryMainTemplate";
import CountryTemplate from "./pages/Countries/CountryTemplate";
import DestinationsPage from "@/pages/DestinationsPage";
import ErrorPage from "@/pages/ErrorPage";
import HelmetWrapper from "@/components/helmetWrapper";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");

const articleList = CountryDetailedList.map((countryData) => ({
  path: countryData.link,
  element: <CountryMainTemplate countryData={countryData} />,
}));
const getCountryListData = (listData, countryName) => {
  return listData.filter((t) => t.countryKey === countryName);
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <App />
      </>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/aboutMe",
        element: (
          <HelmetWrapper
            title="關於我"
            description="bywater，旅居在新加坡的臺灣人，熱愛旅行與分享，在這裡記錄旅途中的所見所聞。"
            path="/aboutMe"
          >
            <AboutMePage />
          </HelmetWrapper>
        ),
      },
      {
        path: "/destinations",
        element: (
          <HelmetWrapper
            title="旅遊目的地"
            description="探索bywater走過的旅遊目的地，包含新加坡、印尼、柬埔寨等地的旅遊攻略與遊記。"
            path="/destinations"
          >
            <DestinationsPage />
          </HelmetWrapper>
        ),
      },
      {
        path: "/life-in-SG",
        element: (
          <HelmetWrapper
            title="在新加坡生活"
            description="分享在新加坡生活的點點滴滴，包含租房、飲食、文化等各方面的生活體驗。"
            path="/life-in-SG"
          >
            <div>Life in SG</div>
          </HelmetWrapper>
        ),
      },
      // {
      //   path: "/travel-tips",
      //   element: (
      //     <>
      //       <div>Travel tips</div>
      //     </>
      //   ),
      // },
      {
        path: "/Singapore",
        element: (
          <CountryTemplate
            countryData={getCountryListData(CountryDetailedList, "Singapore")}
          />
        ),
      },
      {
        path: "/Indonesia",
        element: (
          <CountryTemplate
            countryData={getCountryListData(CountryDetailedList, "Indonesia")}
          />
        ),
      },
      {
        path: "/Cambodia",
        element: (
          <CountryTemplate
            countryData={getCountryListData(CountryDetailedList, "Cambodia")}
          />
        ),
      },
      {
        path: "/Vietnam",
        element: (
          <CountryTemplate
            countryData={getCountryListData(CountryDetailedList, "Vietnam")}
          />
        ),
      },
      {
        path: "",
        element: <Navigate to="/aboutMe" />,
      },

      // {
      //   path: "/India",
      //   element: (
      //     <CountryTemplate
      //       countryData={getCountryListData(CountryDetailedList, "India")}
      //     />
      //   ),
      // },
      // {
      //   path: "/Thailand",
      //   element: (
      //     <CountryTemplate
      //       countryData={getCountryListData(CountryDetailedList, "Indonesia")}
      //     />
      //   ),
      // },
      /**
       *
       * Article starts here...
       *
       *
       *
       **/
      ...articleList,
    ],
  },
]);

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <BaseContextProvider>
        <RouterProvider router={router} />
      </BaseContextProvider>
    </StrictMode>
  );
}
